import * as Actions from '../actionsgazeta';

const initialState = [];

const categorias = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_CATEGORIAS_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_CATEGORIAS_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default categorias;
